<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.9827 11.5075C16.2722 11.7796 16.2722 12.2208 15.9827 12.4929L9.06507 18.9961C8.77562 19.2682 8.30634 19.2682 8.01689 18.9961C7.72744 18.724 7.72744 18.2828 8.01689 18.0107L14.4104 12.0002L8.01689 5.98966C7.72744 5.71756 7.72744 5.27638 8.01689 5.00428C8.30634 4.73217 8.77562 4.73217 9.06507 5.00428L15.9827 11.5075Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconChevronRight',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
